module.exports = __webpack_public_path__ + "static/media/pt.11200186.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/pt.svg
// module id = 1464
// module chunks = 0